var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedloc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.75C11.25 14.7446 11.6451 15.6984 12.3483 16.4017C13.0516 17.1049 14.0054 17.5 15 17.5C15.9946 17.5 16.9484 17.1049 17.6517 16.4017C18.3549 15.6984 18.75 14.7446 18.75 13.75C18.75 12.7554 18.3549 11.8016 17.6517 11.0984C16.9484 10.3951 15.9946 10 15 10C14.0054 10 13.0516 10.3951 12.3483 11.0984C11.6451 11.8016 11.25 12.7554 11.25 13.75Z",
    stroke: "#3C3C3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0713 20.8213L16.7675 26.125C16.2987 26.5933 15.6632 26.8563 15.0006 26.8563C14.338 26.8563 13.7025 26.5933 13.2338 26.125L7.92875 20.8213C6.53028 19.4227 5.57792 17.6409 5.19211 15.7011C4.8063 13.7613 5.00437 11.7506 5.76126 9.92341C6.51815 8.09618 7.79988 6.53443 9.44436 5.43563C11.0888 4.33684 13.0222 3.75037 15 3.75037C16.9778 3.75037 18.9112 4.33684 20.5557 5.43563C22.2001 6.53443 23.4819 8.09618 24.2388 9.92341C24.9956 11.7506 25.1937 13.7613 24.8079 15.7011C24.4221 17.6409 23.4697 19.4227 22.0713 20.8213Z",
    stroke: "#3C3C3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedloc);
export default __webpack_public_path__ + "static/media/savedloc.ed3ed6615d12666c988386aa74d5ad5b.svg";
export { ForwardRef as ReactComponent };